import { ICellRendererParams } from 'ag-grid-community';

import { useAddQueryToUrl } from '@/components/common/TagTabs/useAddQueryToUrl';
import { IMPORTING_TOOL_UPLOADED_FILES_PER_PAGE } from '@/config/common.config';
import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import styles from './action-buttons.module.scss';
import { ImportingToolDocument }
  from './models/getPaginatedDocumentsResult.interface';
import { useGetImportingToolFiles } from './hooks/useGetImportingToolFiles';
import { useGetImportingToolFileLogs } from './hooks/useGetImportingToolFileLogs';
import useImportingToolProcessDocument from './hooks/useImportingToolProcessDocument';
import { ImportMode } from './models/importMode.enum';
import { ImportDocumentStatusEnum } from '@/graphql/contracts/_generated_/contracts';

export default function ActionButtons(
  { data }: ICellRendererParams<ImportingToolDocument>) {

  const { getUploadedFiles } = useGetImportingToolFiles();
  const { getFileLogs } = useGetImportingToolFileLogs();
  const { proccessDocument } = useImportingToolProcessDocument();
  const { getValue } = useAddQueryToUrl();
  const currentPage = parseInt(getValue('page') ?? '1', 10);

  const updateList = () => {
    getUploadedFiles(currentPage, IMPORTING_TOOL_UPLOADED_FILES_PER_PAGE);
  };

  const processFile = (mode: ImportMode): undefined => {
    const input = {
      values: {
        DocumentId: data?.id!,
        Mode: mode
      },
      successCallback: updateList
    };
    proccessDocument(input);
  };

  const downloadLogs = (isProcessed: boolean) => {
    getFileLogs(data?.id!, data?.logFileID!, isProcessed);
  };

  return (
    <div className={styles.actions}>
      {data?.id &&
        <Button
          buttonStyleType={ButtonStyleType.PRIMARY}
          buttonSize='small'
          className={styles['download-logs']}
          onClick={() => downloadLogs(false)}
        >
          Download Original File
        </Button>
      }
      {data?.status.toLowerCase() == ImportDocumentStatusEnum.UPLOADED.toLowerCase() &&
        <Button
          buttonStyleType={ButtonStyleType.PRIMARY}
          buttonSize='small'
          onClick={() => processFile(ImportMode.Validation)}
        >
          Validate
        </Button>
      }
      {data?.status.toLowerCase() == ImportDocumentStatusEnum.VALIDATED.toLowerCase() &&
        <Button
          buttonStyleType={ButtonStyleType.PRIMARY}
          buttonSize='small'
          onClick={() => processFile(ImportMode.Import)}
        >
          Import
        </Button>
      }
      {data?.logFileID && data?.status?.toLowerCase() === 'validationerror' &&
        <Button
          buttonStyleType={ButtonStyleType.WARNING}
          buttonSize='small'
          className={styles['download-logs']}
          onClick={() => downloadLogs(true)}
        >
          Download Processed File
        </Button>
      }
    </div>
  );
}
